import { render, staticRenderFns } from "./ReturnForm.vue?vue&type=template&id=3f012e4c&"
import script from "./ReturnForm.vue?vue&type=script&lang=js&"
export * from "./ReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports